import { Controller } from '@hotwired/stimulus';
import { gsap } from 'gsap';

const CLASSES = {
  expanded: 'is-expanded'
};

export default class extends Controller {
  static targets = ['text', 'trigger'];

  static values = {
    maxHeight: Number,
    closeText: String
  };

  connect() {
    if (!this.hasTriggerTarget || !this.hasTextTarget) return;
    if (this.textTarget.scrollHeight - 100 < this.maxHeightValue) {
      this.triggerTarget.classList.add('hidden');
      return;
    }

    this.textTarget.style.maxHeight = `${this.maxHeightValue}px`;
    this.textTarget.style.overflow = 'hidden';
    this.triggerText = this.triggerTarget.innerText;
    this.triggerTarget.addEventListener('click', this.toggle);
  }

  disconnect() {
    if (!this.hasTriggerTarget) return;

    this.triggerTarget.removeEventListener('click', this.toggle);
  }

  toggle = () => {
    this.element.classList.contains(CLASSES.expanded)
      ? this.close()
      : this.expand();
  };

  expand() {
    this.element.classList.add(CLASSES.expanded);
    this.triggerTarget.innerText = this.closeTextValue;
    const finalHeight = this.textTarget.scrollHeight;

    gsap.to(this.textTarget, {
      maxHeight: finalHeight,
      duration: 0.5,
      ease: 'expo.out'
    });
  }

  close() {
    this.element.classList.remove(CLASSES.expanded);
    this.triggerTarget.innerText = this.triggerText;

    gsap.to(this.textTarget, {
      maxHeight: this.maxHeightValue,
      duration: 0.4,
      ease: 'expo.out'
    });
  }
}
